<app-header [isVisible]="isVisible" [showNavbar]="showNavbar"></app-header>
<div id="wrapper" [class.show-navbar]="showNavbar">
  <div class="container page-wrapper gray-bg" [class.show-navbar]="showNavbar">
    <div class="row">
      <div class="col-12">
        <app-suspended-installer [isInstallerSuspended]="isInstallerSuspended"></app-suspended-installer>
        <router-outlet></router-outlet>
      </div>
    </div>
  </div>
</div>
<app-footer [isVisible]="isVisible && lastScrollTop > 50"></app-footer>
